import {WorkspaceCalendarPanel} from "./workspaceCalendarPanel";
import {IntegrationType} from "@/shared/timrTypes";

export class Microsoft extends WorkspaceCalendarPanel {

	private static INTEGRATION_URL: string;

	public static setIntegrationUrl(url: string) {
		Microsoft.INTEGRATION_URL = url;
	}

	public static getIntegrationUrl(): string {
		return Microsoft.INTEGRATION_URL;
	}

	protected get integrationType(): IntegrationType {
		return IntegrationType.MICROSOFT;
	}

	protected get integrationUrl(): string {
		return Microsoft.getIntegrationUrl();
	}
}
